// Module
var code = "<div data-bind=\"if: $componentTemplateNodes.length\"> <div data-bind=\"template: { nodes: $componentTemplateNodes, data: data}\"></div> </div> <div data-bind=\"if: !$componentTemplateNodes.length\"> <span data-bind=\"text: title\" class=\"title\"></span> </div>";
// Exports
export default code;